export default "__VITE_ASSET__BuFnteRl__"